module.exports = __webpack_public_path__ + "img/senac.ed64a8ae.jpg";